import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'

import AppFrame from './components/AppFrame'
import HeadingBreadcrumbs from './components/HeadingBreadcrumbs'
import { Content, Plane } from './components/SharedStyledComponents'
import { PortalOutlet, PortalProvider, createPortalContext } from 'components/Portal'

const Column = styled.div<{ fullWidth?: boolean }>`
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spaces.space5};
	${({ fullWidth }) =>
		fullWidth &&
		css`
			width: 100%;
		`};
`

const ActionButons = (position: 'left' | 'right') => styled.div`
	position: absolute;
	bottom: ${({ theme }) => theme.spaces.space6};
	${position}: ${({ theme }) => theme.spaces.space6};
	display: flex;
	gap: ${({ theme }) => theme.spaces.space3};
	z-index: ${({ theme }) => theme.zIndexes.above};
`

export const HeadingPortalContext = createPortalContext()
export const ActionButtonsPortalContext = createPortalContext()

type Props = {
	leftColumn: React.ReactNode
	rightColumn: React.ReactNode
	ignoreQueryPath?: boolean
	actionButtonsPosition?: 'left' | 'right'
	removePlaneGap?: boolean
	headingChildrenPosition?: 'left' | 'right'
}

function AdvancedSettingsLayout({
	leftColumn,
	rightColumn,
	ignoreQueryPath = false,
	actionButtonsPosition = 'right',
	removePlaneGap = false,
	headingChildrenPosition = 'left',
}: Props) {
	return (
		<AppFrame>
			<Column fullWidth={!rightColumn}>
				<PortalProvider context={ActionButtonsPortalContext}>
					<PortalProvider context={HeadingPortalContext}>
						<Plane fullWidth={!rightColumn} withoutGap={removePlaneGap}>
							<HeadingBreadcrumbs
								transition={false}
								ignoreQueryPath={ignoreQueryPath}
								childrenPosition={headingChildrenPosition}
							>
								<PortalOutlet context={HeadingPortalContext} />
							</HeadingBreadcrumbs>
							<Content>{leftColumn}</Content>
							<PortalOutlet context={ActionButtonsPortalContext} Component={ActionButons(actionButtonsPosition)} />
						</Plane>
					</PortalProvider>
				</PortalProvider>
			</Column>
			{rightColumn}
		</AppFrame>
	)
}

export default AdvancedSettingsLayout
